import { render, staticRenderFns } from "./PublishSatellites.vue?vue&type=template&id=04fe14b6&"
import script from "./PublishSatellites.vue?vue&type=script&lang=js&"
export * from "./PublishSatellites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports